import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import SocialMediaIcon from '../../../shared/SocialMediaIcon'
import Img from '../../../shared/Img'
import { useAnalytics } from '../../../../common/analytics'

const AuthorBiography = ({ author }) => {
  const { track } = useAnalytics()

  const handleSocialIconClick = useCallback(
    (href, name) => {
      const data = {
        nav_link_section: 'Page',
        click_type: 'Social Media Click',
        click_id: name,
        click_url: href,
        click_text: `FDR-Web | ${name}`,
        track_event: 'link_click',
      }
      track(data)
    },
    [track]
  )

  return (
    <div
      data-testid="biography-item"
      className="m-auto mb-10 mt-5 max-w-2xl px-5 md:px-0"
    >
      <Img
        alt="author"
        src={author.avatar.url}
        dataTestId="author-img"
        className="m-auto h-23 w-23 overflow-hidden rounded-full"
        objectFit="cover"
        priority
        customLoader={false}
        styles={{
          position: 'relative',
          height: '100px',
          width: '100px',
        }}
      />
      <div className="text-center leading-6" data-testid="header">
        <h1
          className="my-2 text-3xl text-blue-700 lg:my-2"
          data-testid="name"
          aria-label="author-name"
        >
          {author.fullName}
        </h1>
        <p
          className="mb-5 text-base text-gray-510 md:my-3 lg:mb-6"
          data-testid="job-title"
        >
          {author.jobTitle}
        </p>
      </div>
      <div className="flex justify-center" data-testid="social-media-icons">
        {author.webPage && (
          <SocialMediaIcon
            id="_webPage"
            type="webPage"
            url={author.webPage}
            onClick={() => handleSocialIconClick(author.webPage, 'WebPage')}
          />
        )}
        {author.facebook && (
          <SocialMediaIcon
            type="facebook"
            url={author.facebook}
            onClick={() => handleSocialIconClick(author.facebook, 'Facebook')}
          />
        )}
        {author.twitter && (
          <SocialMediaIcon
            type="twitter"
            url={`https://twitter.com/${author.twitter}/`}
            onClick={() =>
              handleSocialIconClick(
                `https://twitter.com/${author.twitter}/`,
                'Twitter'
              )
            }
          />
        )}
        {author.linkedIn && (
          <SocialMediaIcon
            type="linkedin"
            url={author.linkedIn}
            onClick={() => handleSocialIconClick(author.linkedIn, 'LinkedIn')}
          />
        )}
      </div>
      <p
        data-testid="author-description"
        className="my-5 text-center text-s text-gray-510 md:mb-8 md:mt-3"
      >
        {author.description}
      </p>
    </div>
  )
}

AuthorBiography.propTypes = {
  author: PropTypes.object.isRequired,
}

export default AuthorBiography
